<script setup lang="ts">
import { iconColors } from 'assets/js/utils';
import { Eye, EyeOff } from 'lucide-vue-next';

interface PasswordInputProps {
  modelValue: string;
  placeholder?: string;
  required?: boolean;
  autocomplete?: string;
  'aria-label'?: string;
}

const props = withDefaults(defineProps<PasswordInputProps>(), {
  placeholder: 'Пароль',
  required: true,
  autocomplete: 'current-password',
  'aria-label': 'Пароль',
});

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const showPassword = ref(false);
const inputId = `password-input-${Math.random().toString(36).substr(2, 9)}`;
</script>

<template>
  <v-input
    :id="inputId"
    :model-value="modelValue"
    :type="showPassword ? 'text' : 'password'"
    :placeholder="placeholder"
    :required="required"
    :autocomplete="autocomplete"
    :aria-label="$props['aria-label']"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #iconRight>
      <button
        type="button"
        class="password-toggle"
        :aria-label="showPassword ? 'Скрыть пароль' : 'Показать пароль'"
        @click="showPassword = !showPassword"
      >
        <Eye
          v-if="showPassword"
          :color="iconColors.primary"
          :size="20"
        />
        <EyeOff
          v-else
          :color="iconColors.primary"
          :size="20"
        />
      </button>
    </template>
  </v-input>
</template>

<style scoped lang="scss">
.password-toggle {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
